exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contacts-panel{position:absolute;background-color:white;border-radius:1em;min-width:20em;min-height:10em;top:50%;left:50%;transform:translate(-50%, -50%);padding:1em;box-sizing:border-box;box-shadow:0px 2px 10px 1px rgba(0,0,0,0.18),0px 3px 12px 3px rgba(0,0,0,0.14)}.contacts-panel h3{margin-top:0.5em;margin-bottom:0.5em;color:#dc002e;padding-bottom:0.5em;border-bottom:1px solid #ddd}.contacts-panel table td{vertical-align:top;padding:0.25em 0}.contacts-panel table td.label{font-weight:500;padding-right:1em;color:#002f60}\n", ""]);

// exports
